import React from "react";
import ReactDOM from "react-dom/client";
import App from "../app";
import { BgLandscapePng } from "../assets";

const bootBg = `url(${BgLandscapePng})`;
document.documentElement.style.backgroundImage = bootBg;
document.documentElement.style.backgroundSize = "cover";
document.documentElement.style.backgroundPosition = "center";
document.documentElement.style.backgroundRepeat = "no-repeat";
document.documentElement.style.height = "100%";
document.documentElement.style.minHeight = "100vh";
document.body.style.margin = "0";
document.body.style.backgroundImage = bootBg;
document.body.style.backgroundSize = "cover";
document.body.style.backgroundPosition = "center";
document.body.style.backgroundRepeat = "no-repeat";
document.body.style.height = "100%";
document.body.style.minHeight = "100vh";
const rootEl = document.getElementById("root") as HTMLElement;
if (rootEl) {
  rootEl.style.backgroundImage = bootBg;
  rootEl.style.backgroundSize = "cover";
  rootEl.style.backgroundPosition = "center";
  rootEl.style.backgroundRepeat = "no-repeat";
  rootEl.style.height = "100%";
  rootEl.style.minHeight = "100vh";
}

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
